import {
  ScrollableComponent
} from "../chunks/chunk.7SUFJ5CO.js";
import "../chunks/chunk.M25GCR2X.js";
import "../chunks/chunk.D2XWPAUR.js";
import "../chunks/chunk.YAGRC5Z4.js";
import {
  require_lodash
} from "../chunks/chunk.K5525XC7.js";
import {
  SelectableListComponent,
  isElementHorizontallyScrolled
} from "../chunks/chunk.TQSZUEGJ.js";
import "../chunks/chunk.CNHJCVTI.js";
import "../chunks/chunk.3GRN2CUK.js";
import "../chunks/chunk.LBF6MTVU.js";
import "../chunks/chunk.7X6D52KI.js";
import {
  Observable,
  ReplaySubject,
  Subject,
  Subscriber,
  __extends,
  async,
  connectableObservableDescriptor,
  fromEvent,
  hostReportError,
  isObject,
  map,
  observable,
  pipe,
  refCount,
  subscribeToArray
} from "../chunks/chunk.DLI4WUT3.js";
import "../chunks/chunk.7YPNNGYZ.js";
import "../chunks/chunk.DBFD4ZAO.js";
import "../chunks/chunk.B7YNIICV.js";
import "../chunks/chunk.AZYLF2D7.js";
import "../chunks/chunk.CE3ZRZXS.js";
import "../chunks/chunk.KPYPODQD.js";
import "../chunks/chunk.CD3DSRSX.js";
import "../chunks/chunk.PXGMVSIO.js";
import "../chunks/chunk.54YXW2TU.js";
import {
  emit
} from "../chunks/chunk.HM4ZRC4T.js";
import "../chunks/chunk.ZX7YPA4S.js";
import {
  getChildElementsByTagName,
  getInnerText,
  hasSlot,
  hasSlotWithSpecificElements,
  hasTextDefaultSlot
} from "../chunks/chunk.Z2CDDKXX.js";
import {
  watch
} from "../chunks/chunk.HBM5K2JV.js";
import {
  YotpoTableRowSize
} from "../chunks/chunk.AREYZEAJ.js";
import {
  __decorateClass,
  __spreadValues,
  __toESM,
  component_styles_default,
  theme_styles_default
} from "../chunks/chunk.U4VUMZVF.js";

// src/components/table/table/table.ts
import { html as html6 } from "lit";
import { classMap as classMap6 } from "lit/directives/class-map.js";
import { customElement as customElement5, property as property4, query as query3, state as state6 } from "lit/decorators.js";

// ../../node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js
var subscribeToPromise = function(promise) {
  return function(subscriber) {
    promise.then(function(value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function(err) {
      return subscriber.error(err);
    }).then(null, hostReportError);
    return subscriber;
  };
};

// ../../node_modules/rxjs/_esm5/internal/symbol/iterator.js
function getSymbolIterator() {
  if (typeof Symbol !== "function" || !Symbol.iterator) {
    return "@@iterator";
  }
  return Symbol.iterator;
}
var iterator = /* @__PURE__ */ getSymbolIterator();

// ../../node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js
var subscribeToIterable = function(iterable) {
  return function(subscriber) {
    var iterator2 = iterable[iterator]();
    do {
      var item = void 0;
      try {
        item = iterator2.next();
      } catch (err) {
        subscriber.error(err);
        return subscriber;
      }
      if (item.done) {
        subscriber.complete();
        break;
      }
      subscriber.next(item.value);
      if (subscriber.closed) {
        break;
      }
    } while (true);
    if (typeof iterator2.return === "function") {
      subscriber.add(function() {
        if (iterator2.return) {
          iterator2.return();
        }
      });
    }
    return subscriber;
  };
};

// ../../node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js
var subscribeToObservable = function(obj) {
  return function(subscriber) {
    var obs = obj[observable]();
    if (typeof obs.subscribe !== "function") {
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    } else {
      return obs.subscribe(subscriber);
    }
  };
};

// ../../node_modules/rxjs/_esm5/internal/util/isArrayLike.js
var isArrayLike = function(x) {
  return x && typeof x.length === "number" && typeof x !== "function";
};

// ../../node_modules/rxjs/_esm5/internal/util/isPromise.js
function isPromise(value) {
  return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

// ../../node_modules/rxjs/_esm5/internal/util/subscribeTo.js
var subscribeTo = function(result) {
  if (!!result && typeof result[observable] === "function") {
    return subscribeToObservable(result);
  } else if (isArrayLike(result)) {
    return subscribeToArray(result);
  } else if (isPromise(result)) {
    return subscribeToPromise(result);
  } else if (!!result && typeof result[iterator] === "function") {
    return subscribeToIterable(result);
  } else {
    var value = isObject(result) ? "an invalid object" : "'" + result + "'";
    var msg = "You provided " + value + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
    throw new TypeError(msg);
  }
};

// ../../node_modules/rxjs/_esm5/internal/innerSubscribe.js
var SimpleInnerSubscriber = /* @__PURE__ */ function(_super) {
  __extends(SimpleInnerSubscriber2, _super);
  function SimpleInnerSubscriber2(parent) {
    var _this = _super.call(this) || this;
    _this.parent = parent;
    return _this;
  }
  SimpleInnerSubscriber2.prototype._next = function(value) {
    this.parent.notifyNext(value);
  };
  SimpleInnerSubscriber2.prototype._error = function(error) {
    this.parent.notifyError(error);
    this.unsubscribe();
  };
  SimpleInnerSubscriber2.prototype._complete = function() {
    this.parent.notifyComplete();
    this.unsubscribe();
  };
  return SimpleInnerSubscriber2;
}(Subscriber);
var SimpleOuterSubscriber = /* @__PURE__ */ function(_super) {
  __extends(SimpleOuterSubscriber2, _super);
  function SimpleOuterSubscriber2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SimpleOuterSubscriber2.prototype.notifyNext = function(innerValue) {
    this.destination.next(innerValue);
  };
  SimpleOuterSubscriber2.prototype.notifyError = function(err) {
    this.destination.error(err);
  };
  SimpleOuterSubscriber2.prototype.notifyComplete = function() {
    this.destination.complete();
  };
  return SimpleOuterSubscriber2;
}(Subscriber);
function innerSubscribe(result, innerSubscriber) {
  if (innerSubscriber.closed) {
    return void 0;
  }
  if (result instanceof Observable) {
    return result.subscribe(innerSubscriber);
  }
  var subscription;
  try {
    subscription = subscribeTo(result)(innerSubscriber);
  } catch (error) {
    innerSubscriber.error(error);
  }
  return subscription;
}

// ../../node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
function distinctUntilChanged(compare, keySelector) {
  return function(source) {
    return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
  };
}
var DistinctUntilChangedOperator = /* @__PURE__ */ function() {
  function DistinctUntilChangedOperator2(compare, keySelector) {
    this.compare = compare;
    this.keySelector = keySelector;
  }
  DistinctUntilChangedOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
  };
  return DistinctUntilChangedOperator2;
}();
var DistinctUntilChangedSubscriber = /* @__PURE__ */ function(_super) {
  __extends(DistinctUntilChangedSubscriber2, _super);
  function DistinctUntilChangedSubscriber2(destination, compare, keySelector) {
    var _this = _super.call(this, destination) || this;
    _this.keySelector = keySelector;
    _this.hasKey = false;
    if (typeof compare === "function") {
      _this.compare = compare;
    }
    return _this;
  }
  DistinctUntilChangedSubscriber2.prototype.compare = function(x, y) {
    return x === y;
  };
  DistinctUntilChangedSubscriber2.prototype._next = function(value) {
    var key;
    try {
      var keySelector = this.keySelector;
      key = keySelector ? keySelector(value) : value;
    } catch (err) {
      return this.destination.error(err);
    }
    var result = false;
    if (this.hasKey) {
      try {
        var compare = this.compare;
        result = compare(this.key, key);
      } catch (err) {
        return this.destination.error(err);
      }
    } else {
      this.hasKey = true;
    }
    if (!result) {
      this.key = key;
      this.destination.next(value);
    }
  };
  return DistinctUntilChangedSubscriber2;
}(Subscriber);

// ../../node_modules/rxjs/_esm5/internal/operators/multicast.js
function multicast(subjectOrSubjectFactory, selector) {
  return function multicastOperatorFunction(source) {
    var subjectFactory;
    if (typeof subjectOrSubjectFactory === "function") {
      subjectFactory = subjectOrSubjectFactory;
    } else {
      subjectFactory = function subjectFactory2() {
        return subjectOrSubjectFactory;
      };
    }
    if (typeof selector === "function") {
      return source.lift(new MulticastOperator(subjectFactory, selector));
    }
    var connectable = Object.create(source, connectableObservableDescriptor);
    connectable.source = source;
    connectable.subjectFactory = subjectFactory;
    return connectable;
  };
}
var MulticastOperator = /* @__PURE__ */ function() {
  function MulticastOperator2(subjectFactory, selector) {
    this.subjectFactory = subjectFactory;
    this.selector = selector;
  }
  MulticastOperator2.prototype.call = function(subscriber, source) {
    var selector = this.selector;
    var subject = this.subjectFactory();
    var subscription = selector(subject).subscribe(subscriber);
    subscription.add(source.subscribe(subject));
    return subscription;
  };
  return MulticastOperator2;
}();

// ../../node_modules/rxjs/_esm5/internal/operators/share.js
function shareSubjectFactory() {
  return new Subject();
}
function share() {
  return function(source) {
    return refCount()(multicast(shareSubjectFactory)(source));
  };
}

// ../../node_modules/rxjs/_esm5/internal/operators/takeUntil.js
function takeUntil(notifier) {
  return function(source) {
    return source.lift(new TakeUntilOperator(notifier));
  };
}
var TakeUntilOperator = /* @__PURE__ */ function() {
  function TakeUntilOperator2(notifier) {
    this.notifier = notifier;
  }
  TakeUntilOperator2.prototype.call = function(subscriber, source) {
    var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
    var notifierSubscription = innerSubscribe(this.notifier, new SimpleInnerSubscriber(takeUntilSubscriber));
    if (notifierSubscription && !takeUntilSubscriber.seenValue) {
      takeUntilSubscriber.add(notifierSubscription);
      return source.subscribe(takeUntilSubscriber);
    }
    return takeUntilSubscriber;
  };
  return TakeUntilOperator2;
}();
var TakeUntilSubscriber = /* @__PURE__ */ function(_super) {
  __extends(TakeUntilSubscriber2, _super);
  function TakeUntilSubscriber2(destination) {
    var _this = _super.call(this, destination) || this;
    _this.seenValue = false;
    return _this;
  }
  TakeUntilSubscriber2.prototype.notifyNext = function() {
    this.seenValue = true;
    this.complete();
  };
  TakeUntilSubscriber2.prototype.notifyComplete = function() {
  };
  return TakeUntilSubscriber2;
}(SimpleOuterSubscriber);

// ../../node_modules/rxjs/_esm5/internal/operators/throttle.js
var defaultThrottleConfig = {
  leading: true,
  trailing: false
};

// ../../node_modules/rxjs/_esm5/internal/operators/throttleTime.js
function throttleTime(duration, scheduler, config) {
  if (scheduler === void 0) {
    scheduler = async;
  }
  if (config === void 0) {
    config = defaultThrottleConfig;
  }
  return function(source) {
    return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
  };
}
var ThrottleTimeOperator = /* @__PURE__ */ function() {
  function ThrottleTimeOperator2(duration, scheduler, leading, trailing) {
    this.duration = duration;
    this.scheduler = scheduler;
    this.leading = leading;
    this.trailing = trailing;
  }
  ThrottleTimeOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
  };
  return ThrottleTimeOperator2;
}();
var ThrottleTimeSubscriber = /* @__PURE__ */ function(_super) {
  __extends(ThrottleTimeSubscriber2, _super);
  function ThrottleTimeSubscriber2(destination, duration, scheduler, leading, trailing) {
    var _this = _super.call(this, destination) || this;
    _this.duration = duration;
    _this.scheduler = scheduler;
    _this.leading = leading;
    _this.trailing = trailing;
    _this._hasTrailingValue = false;
    _this._trailingValue = null;
    return _this;
  }
  ThrottleTimeSubscriber2.prototype._next = function(value) {
    if (this.throttled) {
      if (this.trailing) {
        this._trailingValue = value;
        this._hasTrailingValue = true;
      }
    } else {
      this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
      if (this.leading) {
        this.destination.next(value);
      } else if (this.trailing) {
        this._trailingValue = value;
        this._hasTrailingValue = true;
      }
    }
  };
  ThrottleTimeSubscriber2.prototype._complete = function() {
    if (this._hasTrailingValue) {
      this.destination.next(this._trailingValue);
      this.destination.complete();
    } else {
      this.destination.complete();
    }
  };
  ThrottleTimeSubscriber2.prototype.clearThrottle = function() {
    var throttled = this.throttled;
    if (throttled) {
      if (this.trailing && this._hasTrailingValue) {
        this.destination.next(this._trailingValue);
        this._trailingValue = null;
        this._hasTrailingValue = false;
      }
      throttled.unsubscribe();
      this.remove(throttled);
      this.throttled = null;
    }
  };
  return ThrottleTimeSubscriber2;
}(Subscriber);
function dispatchNext(arg) {
  var subscriber = arg.subscriber;
  subscriber.clearThrottle();
}

// src/utilities/table-model.ts
var import_lodash = __toESM(require_lodash(), 1);
var TableModel = class {
  constructor(params) {
    this.headerCells = [];
    this.cells = [];
    this.bodyTableElement = null;
    this.onUpdate = new Subject();
    this.onUpdate$ = this.onUpdate.pipe(throttleTime(300, void 0, { leading: true }), share());
    this.params = params;
  }
  triggerTableUpdate() {
    this.onUpdate.next();
  }
  updateParameters(params) {
    const newParams = __spreadValues(__spreadValues({}, this.params), params);
    if (!(0, import_lodash.isEqual)(newParams, this.params)) {
      this.params = newParams;
      this.triggerTableUpdate();
    }
  }
  setCell({ row, column }, cell) {
    if (!this.cells[row]) {
      this.cells[row] = [];
    }
    this.cells[row][column] = cell;
    cell.connectToModel({ row, column }, this);
  }
  clearHeaderCells() {
    this.headerCells = [];
  }
  clearCells() {
    this.cells = [];
  }
  setHeaderCell(column, cell) {
    this.headerCells[column] = cell;
    cell.connectToModel({ row: -1, column }, this);
  }
  getCell({ row, column }) {
    if (row === -1) {
      return this.headerCells[column];
    }
    return this.cells[row][column];
  }
  isColumnSticky({ column }) {
    return column < this.params.stickyColumns;
  }
  isLastStickyColumn({ column }) {
    return this.params.isHorizontallyScrolled && column === this.params.stickyColumns - 1;
  }
  setBodyTableElement(tableElement) {
    this.bodyTableElement = tableElement;
  }
  getBodyTableElement() {
    return this.bodyTableElement;
  }
};

// src/components/table/table-header-cell/table-header-cell.ts
import { html as html2 } from "lit";
import { customElement, query, state as state2 } from "lit/decorators.js";
import { classMap as classMap2 } from "lit/directives/class-map.js";

// src/utilities/table-cell-component.ts
import { css, html, LitElement } from "lit";
import { property, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";

// src/utilities/table-cell-component-consts.ts
var CELL_HORIZONTAL_PADDING = 16;
var CELL_VERTICAL_PADDING = 8;
var TINY_CELL_WIDTH = 88;
var SMALL_CELL_WIDTH = 144;
var MEDIUM_CELL_WIDTH = 240;
var LARGE_CELL_WIDTH = 480;
var TINY_CELL_CONTENT_WIDTH = TINY_CELL_WIDTH - CELL_HORIZONTAL_PADDING * 2;
var SMALL_CELL_CONTENT_WIDTH = SMALL_CELL_WIDTH - CELL_HORIZONTAL_PADDING * 2;
var MEDIUM_CELL_CONTENT_WIDTH = MEDIUM_CELL_WIDTH - CELL_HORIZONTAL_PADDING * 2;
var LARGE_CELL_CONTENT_WIDTH = LARGE_CELL_WIDTH - CELL_HORIZONTAL_PADDING * 2;
var TITLE_CELL_HEIGHT = 32;
var MEDIUM_ROW_HEIGHT = 56;
var LARGE_ROW_HEIGHT = 96;
var CELL_TEXT_LINE_MAX_HEIGHT = 16;
var ACTIONS_CELL_WIDTH = 40;
var TABLE_SCROLLBAR_WIDTH = 18;

// src/utilities/table-cell-component.ts
var TableCellComponent = class extends LitElement {
  constructor() {
    super(...arguments);
    this.size = "small" /* small */;
    this.alignment = "left" /* left */;
    this.isTitleCell = false;
    this.sticky = false;
    this.lastSticky = false;
    this.columnIndex = 0;
    this.rowIndex = 0;
    this.isTextOverflow = false;
    this.isTextOverflowChecked = false;
    this.cellText = "";
    this.hasContentSuffix = false;
    this.onDestroy$ = new Subject();
  }
  onPropertyUpdates() {
    if (this.tableModel) {
      this.tableModel.triggerTableUpdate();
    }
  }
  get cellWidth() {
    switch (this.size) {
      case "large" /* large */:
        return LARGE_CELL_WIDTH;
      case "medium" /* medium */:
        return MEDIUM_CELL_WIDTH;
      case "small" /* small */:
        return SMALL_CELL_WIDTH;
      case "tiny" /* tiny */:
        return TINY_CELL_CONTENT_WIDTH;
      case "stretch" /* stretch */:
        return this.clientWidth;
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.onDestroy$.next();
  }
  connectToModel({ row, column }, model) {
    this.rowIndex = row;
    this.columnIndex = column;
    if (this.tableModel !== model) {
      this.tableModel = model;
      this.setStickyCellShift();
      this.tableModel.onUpdate$.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
        this.setStickyCellShift();
      });
    }
  }
  setStickyCellShift() {
    if (!this.tableModel) {
      this.sticky = false;
      return;
    }
    const tableCoordinates = { column: this.columnIndex, row: this.rowIndex };
    this.sticky = this.tableModel.isColumnSticky(tableCoordinates);
    this.lastSticky = this.tableModel.isLastStickyColumn(tableCoordinates);
    if (!this.sticky) {
      return;
    }
    let shift = 0;
    for (let i = 0; i < this.columnIndex; i++) {
      const cell = this.tableModel.getCell({ column: i, row: this.rowIndex });
      shift += cell.cellWidth;
    }
    this.style.setProperty("--left-sticky", shift + "px");
  }
  get cellOverflowMightChange() {
    return !this.isTextOverflowChecked || this.size === "stretch" /* stretch */;
  }
  get estimatedCharactersNumberForOverflow() {
    switch (this.size) {
      case "tiny" /* tiny */:
        return 5;
      case "small" /* small */:
        return 9;
      case "medium" /* medium */:
        return 18;
      case "large" /* large */:
        return 38;
      case "stretch" /* stretch */:
        return 0;
    }
  }
  checkTextOverflows(text, wrappingElement, textVisibleLines = 1) {
    return text.length > this.estimatedCharactersNumberForOverflow && wrappingElement.scrollHeight > CELL_TEXT_LINE_MAX_HEIGHT * textVisibleLines;
  }
  handleSuffixChange() {
    this.hasContentSuffix = hasSlot(this, "content-suffix");
    this.isTextOverflowChecked = false;
  }
  setCellText() {
    if (this.hasContentSuffix) {
      this.cellText = getInnerText(this);
      return;
    }
    if (this.innerText) {
      this.cellText = this.innerText.trim();
      return;
    }
    this.cellText = "";
  }
  renderCell(cellContent) {
    const cellClasses = {
      cell: true,
      "cell--tiny": this.size === "tiny" /* tiny */,
      "cell--small": this.size === "small" /* small */,
      "cell--medium": this.size === "medium" /* medium */,
      "cell--large": this.size === "large" /* large */,
      "cell--stretch": this.size === "stretch" /* stretch */,
      "cell--left": this.alignment === "left" /* left */,
      "cell--center": this.alignment === "center" /* center */,
      "cell--right": this.alignment === "right" /* right */,
      "cell--has-content-suffix": this.hasContentSuffix
    };
    if (this.isTitleCell) {
      return html`
				<th
					part="column"
					role="columnheader"
					class=${classMap(__spreadValues({
        "cell--title": true
      }, cellClasses))}
				>
					${cellContent}
				</th>
			`;
    }
    return html`
			<td
				part="cell"
				role="cell"
				class=${classMap(__spreadValues({
      "cell--body": true
    }, cellClasses))}
			>
				${cellContent}
			</td>
		`;
  }
  renderCellWithTooltip(cellContent, tooltipText, tooltipTitle = "") {
    var _a;
    const boundaryElement = !this.isTitleCell && this.sticky ? (_a = this.tableModel) == null ? void 0 : _a.getBodyTableElement() : null;
    return html` <yotpo-tooltip
			tooltipTitle=${tooltipTitle}
			text=${tooltipText}
			.hoist=${true}
			.boundaryElement=${ifDefined(boundaryElement)}
			class=${classMap({
      "cell-tooltip": true,
      "cell-tooltip--title": this.isTitleCell
    })}
		>
			${this.renderCell(cellContent)}
		</yotpo-tooltip>`;
  }
};
__decorateClass([
  property({ reflect: true })
], TableCellComponent.prototype, "size", 2);
__decorateClass([
  property({ reflect: true })
], TableCellComponent.prototype, "alignment", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "isTitleCell", 2);
__decorateClass([
  property({ reflect: true })
], TableCellComponent.prototype, "sticky", 2);
__decorateClass([
  property({ reflect: true })
], TableCellComponent.prototype, "lastSticky", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "columnIndex", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "rowIndex", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "isTextOverflow", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "isTextOverflowChecked", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "cellText", 2);
__decorateClass([
  state()
], TableCellComponent.prototype, "hasContentSuffix", 2);
__decorateClass([
  watch("size", { waitUntilFirstUpdate: true })
], TableCellComponent.prototype, "onPropertyUpdates", 1);
var tableCellStyles = css`
	${theme_styles_default}
	${component_styles_default}

    :host {
		display: inline-block;
		--border-bottom: 1px solid var(--yotpo-color-general-30);
	}

	:host([sticky='true']) {
		position: -webkit-sticky;
		position: -moz-sticky;
		position: -o-sticky;
		position: -ms-sticky;
		position: sticky;
		z-index: 1;
		left: var(--left-sticky);
	}

	:host([sticky='true']:hover) {
		z-index: 5;
	}

	:host([sticky='true']):after {
		content: '';
		display: block;
		background: linear-gradient(90deg, rgba(28, 29, 33, 0.12), transparent);
		top: 0px;
		position: absolute;
		height: 98%;
		width: 16px;
		opacity: 0;
		transition: opacity 0.5s;
		right: -16px;
	}

	:host([sticky='true'][lastSticky='true']):after {
		opacity: 1;
	}

	:host([size='stretch']) {
		flex: 1 1 0;
		overflow: hidden;
	}

	.cell {
		position: relative;
		background-color: var(--background-color);
		border-bottom: var(--border-bottom);
		min-width: ${TINY_CELL_WIDTH}px;
		display: flex;
		align-items: center;
		padding: ${CELL_VERTICAL_PADDING}px ${CELL_HORIZONTAL_PADDING}px;
	}

	.cell--tiny {
		width: ${TINY_CELL_WIDTH}px;
	}

	.cell--tiny .cell-content {
		width: ${TINY_CELL_CONTENT_WIDTH}px;
	}

	.cell--small {
		width: ${SMALL_CELL_WIDTH}px;
	}

	.cell--small .cell-content {
		width: ${SMALL_CELL_CONTENT_WIDTH}px;
	}

	.cell--medium {
		width: ${MEDIUM_CELL_WIDTH}px;
	}

	.cell--medium .cell-content {
		width: ${MEDIUM_CELL_CONTENT_WIDTH}px;
	}

	.cell--large {
		width: ${LARGE_CELL_WIDTH}px;
	}

	.cell--large .cell-content {
		width: ${LARGE_CELL_CONTENT_WIDTH}px;
	}

	.cell--stretch {
		width: 100%;
	}

	.cell--stretch .cell-content {
		width: 100%;
	}

	.cell--left .cell-content {
		justify-content: start;
		text-align: start;
	}

	.cell--center .cell-content {
		justify-content: center;
		text-align: center;
	}

	.cell--right .cell-content {
		justify-content: end;
		text-align: end;
	}

	.cell--body,
	.cell-tooltip {
		height: 100%;
	}

	.cell--title,
	.cell-tooltipe--title {
		height: ${TITLE_CELL_HEIGHT}px;
	}

	.cell-overflowable-text {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		word-break: break-word;
		height: 100%;
	}

	.cell--has-content-suffix .cell-content-suffix {
		flex: 0 0 auto;
		display: inline-block;
		margin-left: var(--yotpo-spacing-small);
	}
`;

// src/components/table/table-header-cell/table-header-cell.styles.ts
import { css as css2 } from "lit";
var table_header_cell_styles_default = css2`
	${theme_styles_default}
	${component_styles_default}
	${tableCellStyles}

	:host {
		--background-color: var(--yotpo-color-general-20);
	}

	.cell-content {
		display: flex;
		align-items: center;
	}

	.cell-content:not(.cell--has-content) .cell-data {
		display: none;
	}

	.cell-data {
		height: 16px;
		oveflow: hidden;
		-webkit-line-clamp: 1;
	}
`;

// src/components/table/table-header-cell/table-header-cell.ts
var TABLE_HEADER_CELL_TAG = "yotpo-table-header-cell";
var YotpoTableHeaderCell = class extends TableCellComponent {
  constructor() {
    super();
    this.hasContent = false;
    this.cells = [];
    this.isTitleCell = true;
  }
  async firstUpdated() {
    await this.updateComplete;
    this.setCellText();
  }
  setCellOverflowStatus() {
    if (!this.cellOverflowMightChange) {
      return;
    }
    if (!this.cellText) {
      this.setCellText();
    }
    this.isTextOverflow = this.checkTextOverflows(this.cellText, this.contentSlot);
    this.isTextOverflowChecked = true;
  }
  handleContentChange() {
    this.hasContent = hasTextDefaultSlot(this, ["content-suffix"]);
    this.isTextOverflowChecked = false;
  }
  render() {
    const headerCell = html2`<span
			class=${classMap2({
      "cell-content yotpo-theme-light": true,
      "cell--has-content": this.hasContent
    })}
			@mouseenter=${this.setCellOverflowStatus}
		>
			<slot
				class="cell-data yotpo-text-primary yotpo-text-small yotpo-text-bold cell-overflowable-text"
				@slotchange=${this.handleContentChange}
			></slot>
			<slot
				name="content-suffix"
				part="content-suffix"
				class="cell-content-suffix"
				@slotchange=${this.handleSuffixChange}
			>
			</slot>
		</span>`;
    if (this.isTextOverflow) {
      return this.renderCellWithTooltip(headerCell, this.cellText);
    }
    return this.renderCell(headerCell);
  }
};
YotpoTableHeaderCell.styles = table_header_cell_styles_default;
__decorateClass([
  query(".cell-data")
], YotpoTableHeaderCell.prototype, "contentSlot", 2);
__decorateClass([
  state2()
], YotpoTableHeaderCell.prototype, "hasContent", 2);
__decorateClass([
  state2()
], YotpoTableHeaderCell.prototype, "cells", 2);
YotpoTableHeaderCell = __decorateClass([
  customElement(TABLE_HEADER_CELL_TAG)
], YotpoTableHeaderCell);

// src/components/table/table-cell/table-cell.ts
import { html as html3 } from "lit";
import { customElement as customElement2, property as property2, query as query2, state as state3 } from "lit/decorators.js";
import { classMap as classMap3 } from "lit/directives/class-map.js";

// src/components/table/table-cell/table-cell.styles.ts
import { css as css3 } from "lit";
var table_cell_styles_default = css3`
	${theme_styles_default}
	${component_styles_default}
	${tableCellStyles}

	:host {
		--background-color: var(--yotpo-color-white);
	}

	.cell-content {
		display: flex;
		align-items: center;
		overflow: hidden;
		height: 100%;
	}

	.cell-prefix {
		flex: 0 0 auto;
		margin-right: var(--yotpo-spacing-medium);
		font-size: 16px;
		color: var(--yotpo-font-color-light-secondary);
	}

	.cell-suffix {
		flex: 0 0 auto;
		margin-left: var(--yotpo-spacing-medium);
		font-size: 16px;
		color: var(--yotpo-font-color-light-secondary);
	}

	.cell-data {
		display: flex;
		flex-direction: column;
	}

	.cell--none-textual .cell-data,
	.cell--none-textual .cell-inner-data {
		width: 100%;
	}

	.cell--tiny .cell-data {
		max-width: ${TINY_CELL_CONTENT_WIDTH}px;
	}

	.cell--small .cell-data {
		max-width: ${SMALL_CELL_CONTENT_WIDTH}px;
	}

	.cell--medium .cell-data {
		max-width: ${MEDIUM_CELL_CONTENT_WIDTH}px;
	}

	.cell--large .cell-data {
		max-width: ${LARGE_CELL_CONTENT_WIDTH}px;
	}

	.cell-content:not(.cell--has-subtitle) .cell-inner-data {
		-webkit-line-clamp: 2;
	}

	.cell-content.cell--has-subtitle .cell-inner-data {
		-webkit-line-clamp: 1;
	}

	.cell-subtitle {
		-webkit-line-clamp: 1;
	}

	.cell--left .cell-data {
		justify-content: start;
		text-align: start;
	}

	.cell--center .cell-data {
		text-align: start;
		width: fit-content;
	}

	.cell--right .cell-data {
		justify-content: end;
		text-align: end;
	}

	.cell-inner-data-wrapper {
		display: flex;
		align-items: center;
	}
`;

// src/components/table/table-cell/table-cell.ts
var TABLE_CELL_TAG = "yotpo-table-cell";
var YotpoTableCell = class extends TableCellComponent {
  constructor() {
    super(...arguments);
    this.isTypeText = false;
    this.hasSubtitle = false;
    this.subtitle = "";
    this.prefixIcon = "";
    this.suffixIcon = "";
    this.bold = false;
  }
  async firstUpdated() {
    await this.updateComplete;
    this.isTypeText = hasTextDefaultSlot(this, ["content-suffix"]);
    if (this.isTypeText) {
      this.hasSubtitle = typeof this.subtitle === "string" && this.subtitle.trim() !== "";
      this.setCellText();
    }
  }
  setCellOverflowStatus() {
    if (!(this.isTypeText && this.cellOverflowMightChange)) {
      return;
    }
    if (!this.cellText) {
      this.setCellText();
    }
    this.isTextOverflow = this.hasSubtitle ? this.checkTextOverflowWithSubtitle() : this.checkTextOverflows(this.cellText, this.contentSlot, 2);
    this.isTextOverflowChecked = true;
  }
  checkTextOverflowWithSubtitle() {
    return this.checkTextOverflows(this.cellText, this.contentSlot) || this.checkTextOverflows(this.subtitle, this.cellSubtitle);
  }
  handleContentChange() {
    this.isTextOverflowChecked = false;
  }
  render() {
    const cell = html3`<span
			class=${classMap3({
      "cell-content": true,
      "yotpo-theme-light": true,
      "cell--has-subtitle": this.hasSubtitle,
      "cell--none-textual": !this.isTypeText
    })}
			@mouseenter=${this.setCellOverflowStatus}
		>
			${this.prefixIcon && this.isTypeText ? html3`<yotpo-icon part="prefix" class="cell-prefix" name=${this.prefixIcon}></yotpo-icon>` : ""}
			<div class="cell-data">
				<span class="cell-inner-data-wrapper">
					<slot
						class=${classMap3({
      "cell-inner-data yotpo-text-primary yotpo-text-small cell-overflowable-text": true,
      "yotpo-text-bold": this.bold
    })}
						@slotchange=${this.handleContentChange}
					>
					</slot>
					<slot
						name="content-suffix"
						part="content-suffix"
						class="cell-content-suffix"
						@slotchange=${this.handleSuffixChange}
					>
					</slot>
				</span>
				${this.hasSubtitle ? html3`<span
							part="subtitle"
							class="cell-subtitle yotpo-text-secondary yotpo-text-small cell-overflowable-text"
							>${this.subtitle}</span
					  >` : ""}
			</div>
			${this.suffixIcon && this.isTypeText ? html3`<yotpo-icon part="suffix" class="cell-suffix" name=${this.suffixIcon}></yotpo-icon>` : ""}
		</span>`;
    if (this.isTextOverflow) {
      const tooltipText = this.hasSubtitle ? this.subtitle : this.cellText;
      const tooltipTitle = this.hasSubtitle ? this.cellText : "";
      return this.renderCellWithTooltip(cell, tooltipText, tooltipTitle);
    }
    return this.renderCell(cell);
  }
};
YotpoTableCell.styles = table_cell_styles_default;
__decorateClass([
  query2(".cell-inner-data")
], YotpoTableCell.prototype, "contentSlot", 2);
__decorateClass([
  query2(".cell-subtitle")
], YotpoTableCell.prototype, "cellSubtitle", 2);
__decorateClass([
  query2(".cell-data")
], YotpoTableCell.prototype, "cellData", 2);
__decorateClass([
  state3()
], YotpoTableCell.prototype, "isTypeText", 2);
__decorateClass([
  state3()
], YotpoTableCell.prototype, "hasSubtitle", 2);
__decorateClass([
  property2({ reflect: true })
], YotpoTableCell.prototype, "subtitle", 2);
__decorateClass([
  property2({ reflect: true })
], YotpoTableCell.prototype, "prefixIcon", 2);
__decorateClass([
  property2({ reflect: true })
], YotpoTableCell.prototype, "suffixIcon", 2);
__decorateClass([
  property2({ type: Boolean, reflect: true })
], YotpoTableCell.prototype, "bold", 2);
__decorateClass([
  watch("subtitle", { waitUntilFirstUpdate: true })
], YotpoTableCell.prototype, "handleContentChange", 1);
YotpoTableCell = __decorateClass([
  customElement2(TABLE_CELL_TAG)
], YotpoTableCell);

// src/components/table/table-row/table-row.ts
import { html as html5, LitElement as LitElement3 } from "lit";
import { customElement as customElement4, state as state5 } from "lit/decorators.js";
import { classMap as classMap5 } from "lit/directives/class-map.js";

// src/components/table/table-actions-cell/table-actions-cell.ts
import { html as html4, LitElement as LitElement2 } from "lit";
import { customElement as customElement3, property as property3, state as state4 } from "lit/decorators.js";
import { classMap as classMap4 } from "lit/directives/class-map.js";

// src/components/table/table-actions-cell/table-actions-cell.styles.ts
import { css as css4 } from "lit";
var table_actions_cell_styles_default = css4`
	${theme_styles_default}
	${component_styles_default}

	:host {
		display: inline-block;
		--border-bottom: 1px solid var(--yotpo-color-general-30);
		--background-color: rgba(255, 255, 255, 0.8);
		position: -webkit-sticky;
		position: -moz-sticky;
		position: -o-sticky;
		position: -ms-sticky;
		position: sticky;
		right: 0;
	}

	.actions-cell {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 16px 8px;
		width: ${ACTIONS_CELL_WIDTH}px;
		height: 100%;
		background-color: var(--background-color);
		border-bottom: var(--border-bottom);
	}

	.actions-cell--medium {
		height: ${MEDIUM_ROW_HEIGHT}px;
	}

	.actions-cell--large {
		height: ${LARGE_ROW_HEIGHT}px;
	}

	.actions-cell--secondary-actions {
		height: 100%;
		padding: 16px 8px;
		position: absolute;
		z-index: 10;
		flex: 0 0 auto;
	}

	.actions-cell:not(.actions-cell--has-secondary-actions) .actions-cell--secondary-actions {
		display: none;
	}

	.actions-cell--main-action {
		display: flex;
		justify-content: end;
		align-items: center;
		padding: 16px 8px;
		position: absolute;
		background-color: var(--background-color);
		height: 100%;
	}

	.actions-cell:not(.actions-cell--has-secondary-actions) .actions-cell--main-action {
		max-width: 160px;
		right: 0;
	}

	.actions-cell.actions-cell--has-secondary-actions .actions-cell--main-action {
		max-width: 128px;
		right: 32px;
	}
`;

// src/components/table/table-actions-cell/table-actions-cell.ts
var TABLE_ACTIONS_CELL_TAG = "yotpo-table-actions-cell";
var SECONDARY_ACTIONS_MENU_TAG = "yotpo-secondary-actions-menu";
var SECONDARY_ACTIONS_SLOT = "secondary-actions";
var YotpoTableActionsCell = class extends LitElement2 {
  constructor() {
    super(...arguments);
    this.mainActionLabel = "";
    this.size = "medium" /* medium */;
    this.isHovered = false;
    this.hasSecondaryActions = false;
    this.secondaryActionsMenu = null;
  }
  connectToModel(model) {
    if (this.tableModel !== model) {
      this.tableModel = model;
      this.setSecondaryActionsMenuBoundary();
    }
  }
  handleSecondaryActionsSlotChange() {
    var _a;
    this.hasSecondaryActions = hasSlotWithSpecificElements(this, [SECONDARY_ACTIONS_MENU_TAG], SECONDARY_ACTIONS_SLOT);
    this.secondaryActionsMenu = (_a = getChildElementsByTagName(this, SECONDARY_ACTIONS_MENU_TAG)) == null ? void 0 : _a[0];
    this.setSecondaryActionsMenuBoundary();
  }
  hideSecondaryActionsMenu() {
    if (!this.secondaryActionsMenu)
      return;
    this.secondaryActionsMenu.hide();
  }
  setSecondaryActionsMenuBoundary() {
    if (this.secondaryActionsMenu && this.tableModel) {
      this.secondaryActionsMenu.popover.boundaryElement = this.tableModel.getBodyTableElement();
    }
  }
  get mainAction() {
    return html4`<div class="actions-cell--main-action">
			<yotpo-button
				tabindex="1"
				size=${"small" /* small */}
				aria-title=${this.mainActionLabel}
				@click=${() => emit(this, "yotpo-main-action" /* mainAction */)}
			>
				${this.mainActionLabel}
			</yotpo-button>
		</div>`;
  }
  get secondaryActions() {
    return html4`<slot
			name="secondary-actions"
			@slotchange=${this.handleSecondaryActionsSlotChange}
			@yotpo-select=${this.handleSecondaryActionsSlotChange}
			class="actions-cell--secondary-actions"
			tabindex="2"
		>
		</slot>`;
  }
  get mainCellContent() {
    if (!this.mainActionLabel) {
      return "";
    }
    if (this.isHovered) {
      return this.mainAction;
    }
    if (!this.isHovered && !this.hasSecondaryActions) {
      return html4`<yotpo-icon name="chevron-right-small"></yotpo-icon>`;
    }
    return "";
  }
  render() {
    return html4`
			<td
				part="cell"
				role="cell"
				class=${classMap4({
      "actions-cell": true,
      "actions-cell--has-secondary-actions": this.hasSecondaryActions,
      "actions-cell--medium": this.size === "medium" /* medium */,
      "actions-cell--large": this.size === "large" /* large */
    })}
			>
				${this.mainCellContent} ${this.secondaryActions}
			</td>
		`;
  }
};
YotpoTableActionsCell.styles = table_actions_cell_styles_default;
__decorateClass([
  property3()
], YotpoTableActionsCell.prototype, "mainActionLabel", 2);
__decorateClass([
  state4()
], YotpoTableActionsCell.prototype, "size", 2);
__decorateClass([
  state4()
], YotpoTableActionsCell.prototype, "isHovered", 2);
__decorateClass([
  state4()
], YotpoTableActionsCell.prototype, "hasSecondaryActions", 2);
__decorateClass([
  state4()
], YotpoTableActionsCell.prototype, "secondaryActionsMenu", 2);
YotpoTableActionsCell = __decorateClass([
  customElement3(TABLE_ACTIONS_CELL_TAG)
], YotpoTableActionsCell);

// src/components/table/table-row/table-row.styles.ts
import { css as css5 } from "lit";
var table_row_styles_default = css5`
	${theme_styles_default}
	${component_styles_default}

	:host {
		position: initial;
		display: block;
		--border-bottom-row: 1px solid var(--yotpo-color-general-30);
	}

	.row {
		display: flex;
	}

	.row--medium {
		height: ${MEDIUM_ROW_HEIGHT}px;
	}

	.row--large {
		height: ${LARGE_ROW_HEIGHT}px;
	}

	.row ::slotted(*) {
		--border-bottom: var(--border-bottom-row);
	}

	.row:hover ::slotted(yotpo-table-cell) {
		--background-color: var(--yotpo-color-general-10);
	}

	.row:hover ::slotted(yotpo-table-actions-cell) {
		--background-color: rgba(244, 246, 249, 0.8);
	}

	.row-content:not(.row--has-cells) {
		display: none;
	}

	.row--has-main-action {
		cursor: pointer;
	}
`;

// src/components/table/table-row/table-row.ts
var TABLE_ROW_TAG = "yotpo-table-row";
var ROW_Z_INDEX = "1";
var HOVERED_ROW_Z_INDEX = "3";
var YotpoTableRow = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.hasActionsColumn = false;
    this.size = "medium" /* medium */;
    this.hasCells = false;
    this.actionsCell = null;
    this.hasMainAction = false;
  }
  async firstUpdated() {
    await this.updateComplete;
    if (this.actionsCell) {
      this.setInitialCellActionsDefinitions();
    }
  }
  handleSlotChange() {
    var _a;
    this.hasCells = hasSlotWithSpecificElements(this, [TABLE_CELL_TAG, TABLE_ACTIONS_CELL_TAG]);
    this.actionsCell = (_a = getChildElementsByTagName(this, TABLE_ACTIONS_CELL_TAG)) == null ? void 0 : _a[0];
    this.setHasMainAction();
  }
  handleClick(e) {
    var _a;
    if (this.hasMainAction && ((_a = e.target) == null ? void 0 : _a.tagName.toLowerCase()) === TABLE_CELL_TAG) {
      emit(this, "yotpo-main-action" /* mainAction */);
    }
  }
  handleMainAction(e) {
    var _a;
    if (((_a = e.target) == null ? void 0 : _a.tagName.toLowerCase()) === TABLE_ACTIONS_CELL_TAG) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
  }
  handleMouseOver() {
    if (this.actionsCell) {
      this.actionsCell.isHovered = true;
      this.actionsCell.style.zIndex = HOVERED_ROW_Z_INDEX;
    }
  }
  handleMouseLeave() {
    if (this.actionsCell) {
      this.actionsCell.isHovered = false;
      this.actionsCell.style.zIndex = ROW_Z_INDEX;
      this.actionsCell.hideSecondaryActionsMenu();
    }
  }
  handleHasActionsColumnChanged() {
    if (this.actionsCell) {
      this.actionsCell.style.display = this.hasActionsColumn ? "inline-block" : "none";
    }
    this.setHasMainAction();
  }
  handleSizeChanged() {
    if (this.actionsCell) {
      this.actionsCell.size = this.size;
    }
  }
  setInitialCellActionsDefinitions() {
    requestAnimationFrame(() => this.handleHasActionsColumnChanged());
    if (this.size !== "medium" /* medium */) {
      requestAnimationFrame(() => this.handleSizeChanged());
    }
  }
  setHasMainAction() {
    var _a;
    this.hasMainAction = this.hasActionsColumn && this.actionsCell !== null && ((_a = this.actionsCell) == null ? void 0 : _a.mainActionLabel) !== "";
  }
  get rowContent() {
    return html5`<slot
			class=${classMap5({
      "row-content": true,
      "row--has-cells": this.hasCells
    })}
			@slotchange=${this.handleSlotChange}
		>
		</slot>`;
  }
  render() {
    return html5`<tr
			part="row"
			role="row"
			class="row"
			class=${classMap5({
      row: true,
      "row--medium": this.size === "medium" /* medium */,
      "row--large": this.size === "large" /* large */,
      "row--has-main-action": this.hasMainAction
    })}
			@click=${this.handleClick}
			@yotpo-main-action=${this.handleMainAction}
			@mouseenter=${this.handleMouseOver}
			@mouseleave=${this.handleMouseLeave}
		>
			${this.rowContent}
		</tr>`;
  }
};
YotpoTableRow.styles = table_row_styles_default;
__decorateClass([
  state5()
], YotpoTableRow.prototype, "hasActionsColumn", 2);
__decorateClass([
  state5()
], YotpoTableRow.prototype, "size", 2);
__decorateClass([
  state5()
], YotpoTableRow.prototype, "hasCells", 2);
__decorateClass([
  state5()
], YotpoTableRow.prototype, "actionsCell", 2);
__decorateClass([
  state5()
], YotpoTableRow.prototype, "hasMainAction", 2);
__decorateClass([
  watch("hasActionsColumn", { waitUntilFirstUpdate: true })
], YotpoTableRow.prototype, "handleHasActionsColumnChanged", 1);
__decorateClass([
  watch("size", { waitUntilFirstUpdate: true })
], YotpoTableRow.prototype, "handleSizeChanged", 1);
YotpoTableRow = __decorateClass([
  customElement4(TABLE_ROW_TAG)
], YotpoTableRow);

// src/components/table/table/table.styles.ts
import { css as css6 } from "lit";
var table_styles_default = css6`
	${theme_styles_default}
	${component_styles_default}

	.table__wrapper {
		display: flex;
		width: 100%;
		height: 100%;
		flex-direction: column;
		background-color: var(--yotpo-color-white);
		overflow: hidden;
		position: relative;
	}

	.table__wrapper--has-border {
		border: 1px solid var(--yotpo-color-general-30);
		border-radius: var(--yotpo-border-radius-large);
	}

	.table {
		display: inline-block;
		overflow: auto;
	}

	.header-table {
		height: 32px;
		flex: 0 0 auto;
		scrollbar-width: none;
	}

	.header-table::-webkit-scrollbar {
		display: none;
	}

	.header {
		display: inline-block;
		width: 100%;
	}

	.header-columns {
		display: flex;
	}

	.header:not(.header--has-columns) .header-columns {
		display: none;
	}

	.body {
		display: flex;
		flex-direction: column;
	}

	.body:not(.body--has-content) .body-content {
		display: none;
	}

	.body-content::slotted(:last-child) {
		--border-bottom-row: none;
	}

	.dummy-header-cell {
		background-color: var(--yotpo-color-general-20);
		border-bottom: 1px solid var(--yotpo-color-general-30);
		height: ${TITLE_CELL_HEIGHT}px;
		flex: 0 0 auto;
	}
	.dummy-action-header-cell {
		width: ${ACTIONS_CELL_WIDTH}px;
	}

	.dummy-scrollbar-header-cell {
		width: ${TABLE_SCROLLBAR_WIDTH}px;
	}
`;

// src/components/table/table/table.ts
var YotpoTable = class extends ScrollableComponent {
  constructor() {
    super(...arguments);
    this.customEvents = ["yotpo-scroll-end" /* scrollEnd */];
    this.hasColumns = false;
    this.hasContent = false;
    this.hasVerticalScroll = false;
    this.stickyColumns = 1;
    this.hasActionsColumn = false;
    this.hasBorder = true;
    this.rowSize = "medium" /* medium */;
    this.maxHeight = "none";
    this.tableModel = new TableModel({ stickyColumns: this.stickyColumns, isHorizontallyScrolled: false });
    this.rowsChanged$ = new ReplaySubject();
    this.columnsChanged$ = new ReplaySubject();
    this.onDestroy$ = new Subject();
    this.tableResizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => this.checkVerticalScroll());
    });
  }
  async firstUpdated() {
    super.firstUpdated();
    await this.updateComplete;
    this.tableModel.setBodyTableElement(this.bodyTable);
    this.subscribeOnTableScroll();
    this.rowsChanged$.pipe(this.changePipe()).subscribe(() => {
      this.setBodyCells();
    });
    this.columnsChanged$.pipe(this.changePipe()).subscribe(() => {
      this.setHeaderCells();
    });
    this.handleStickyColumnsChanged();
    if (this.tableBase instanceof HTMLElement) {
      this.tableResizeObserver.observe(this.tableBase);
    }
  }
  changePipe() {
    return pipe(throttleTime(300, void 0, { trailing: false, leading: true }), takeUntil(this.onDestroy$));
  }
  checkVerticalScroll() {
    this.hasVerticalScroll = this.bodyTable.scrollHeight > this.bodyTable.clientHeight;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.onDestroy$.next();
    if (this.tableBase instanceof HTMLElement) {
      this.tableResizeObserver.unobserve(this.tableBase);
    }
  }
  handleStickyColumnsChanged() {
    this.tableModel.updateParameters({ stickyColumns: this.stickyColumns });
  }
  handleRowsDefinitionsChanged() {
    const rows = getChildElementsByTagName(this, TABLE_ROW_TAG);
    rows.forEach((row) => {
      row.hasActionsColumn = this.hasActionsColumn;
      row.size = this.rowSize;
    });
  }
  handleHeaderSlotChange() {
    this.hasColumns = hasSlotWithSpecificElements(this, [TABLE_HEADER_CELL_TAG], "columns");
    if (!this.hasColumns) {
      console.error(`Not all slots marked as 'columns' are of the tag ${TABLE_HEADER_CELL_TAG}, not rendering header at all`);
      return;
    }
    this.columnsChanged$.next();
  }
  handleBodySlotChange() {
    this.hasContent = hasSlotWithSpecificElements(this, [TABLE_ROW_TAG]);
    if (!this.hasContent) {
      console.error(`You probably tried to render something except ${TABLE_ROW_TAG} or ${TABLE_HEADER_CELL_TAG} inside of yotpo-table. This is not allowed. Not rendering table body at all `);
      return;
    }
    this.rowsChanged$.next();
    this.initializeRows();
  }
  handleBodyTableScroll() {
    this.headerTable.scrollLeft = this.bodyTable.scrollLeft;
  }
  subscribeOnTableScroll() {
    fromEvent(this.bodyTable, "scroll").pipe(map(() => isElementHorizontallyScrolled(this.bodyTable)), distinctUntilChanged(), takeUntil(this.onDestroy$)).subscribe((isScrolled) => {
      this.tableModel.updateParameters({ isHorizontallyScrolled: isScrolled });
    });
  }
  setHeaderCells() {
    if (!this.hasColumns)
      return;
    this.tableModel.clearHeaderCells();
    getChildElementsByTagName(this, TABLE_HEADER_CELL_TAG).forEach((cell, i) => {
      this.tableModel.setHeaderCell(i, cell);
    });
  }
  initializeRows() {
    if (this.hasActionsColumn || this.rowSize !== "medium" /* medium */) {
      requestAnimationFrame(() => this.handleRowsDefinitionsChanged());
    }
  }
  setBodyCells() {
    if (!this.hasContent)
      return;
    const rows = getChildElementsByTagName(this, TABLE_ROW_TAG);
    this.tableModel.clearCells();
    rows.forEach((row, rowIndex) => {
      var _a, _b;
      getChildElementsByTagName(row, TABLE_CELL_TAG).forEach((cell, columnIndex) => {
        this.tableModel.setCell({ row: rowIndex, column: columnIndex }, cell);
      });
      (_b = (_a = row.getElementsByTagName(TABLE_ACTIONS_CELL_TAG)) == null ? void 0 : _a.item(0)) == null ? void 0 : _b.connectToModel(this.tableModel);
    });
  }
  get headerTableContent() {
    return html6`<table
			part="header-table"
			class="table header-table"
			@wheel=${(event) => event.preventDefault()}
			border="0"
			cellspacing="0"
			cellpadding="0"
		>
			<thead
				part="header"
				class=${classMap6({
      header: true,
      "header--has-columns": this.hasColumns
    })}
			>
				${this.headerContent}
			</thead>
		</table>`;
  }
  get headerContent() {
    return html6` <tr part="columns" role="row" class="header-columns">
			${this.columnsContent}
			${this.hasActionsColumn ? html6` <th class="dummy-header-cell dummy-action-header-cell"></th>` : ""}
			${this.hasVerticalScroll ? html6` <th class="dummy-header-cell dummy-scrollbar-header-cell"></th>` : ""}
		</tr>`;
  }
  get columnsContent() {
    return html6` <slot name="columns" @slotchange=${this.handleHeaderSlotChange}></slot>`;
  }
  get bodyTableContent() {
    return html6`<table
			part="body-table"
			yotpo-scrollable-element
			class="table body-table yotpo-scrollbar"
			border="0"
			cellspacing="0"
			cellpadding="0"
			@scroll=${this.handleBodyTableScroll}
		>
			<tbody
				part="body"
				class=${classMap6({
      "body yotpo-scrollbar": true,
      "body--has-content": this.hasContent
    })}
			>
				${this.bodyContent}
			</tbody>
		</table>`;
  }
  get bodyContent() {
    return html6` <slot class="body-content" @slotchange=${this.handleBodySlotChange}></slot>`;
  }
  render() {
    return html6`
			<div
				part="base"
				style="max-height: ${this.maxHeight}"
				class=${classMap6({
      table__wrapper: true,
      "table__wrapper--has-border": this.hasBorder
    })}
			>
				<slot name="header"></slot>
				${this.headerTableContent} ${this.bodyTableContent}
			</div>
		`;
  }
};
YotpoTable.styles = table_styles_default;
__decorateClass([
  query3('[part="base"]')
], YotpoTable.prototype, "tableBase", 2);
__decorateClass([
  query3(".body-table")
], YotpoTable.prototype, "bodyTable", 2);
__decorateClass([
  query3(".header-table")
], YotpoTable.prototype, "headerTable", 2);
__decorateClass([
  state6()
], YotpoTable.prototype, "hasColumns", 2);
__decorateClass([
  state6()
], YotpoTable.prototype, "hasContent", 2);
__decorateClass([
  state6()
], YotpoTable.prototype, "hasVerticalScroll", 2);
__decorateClass([
  property4({ reflect: true })
], YotpoTable.prototype, "stickyColumns", 2);
__decorateClass([
  property4({ type: Boolean, reflect: true })
], YotpoTable.prototype, "hasActionsColumn", 2);
__decorateClass([
  property4({ type: Boolean, reflect: true })
], YotpoTable.prototype, "hasBorder", 2);
__decorateClass([
  property4({ type: YotpoTableRowSize, reflect: true })
], YotpoTable.prototype, "rowSize", 2);
__decorateClass([
  property4({ reflect: true })
], YotpoTable.prototype, "maxHeight", 2);
__decorateClass([
  watch("stickyColumns", { waitUntilFirstUpdate: true })
], YotpoTable.prototype, "handleStickyColumnsChanged", 1);
__decorateClass([
  watch("hasActionsColumn", { waitUntilFirstUpdate: true }),
  watch("rowSize", { waitUntilFirstUpdate: true })
], YotpoTable.prototype, "handleRowsDefinitionsChanged", 1);
YotpoTable = __decorateClass([
  customElement5("yotpo-table")
], YotpoTable);

// src/components/table/table-header/table-header.ts
import { html as html7, LitElement as LitElement4 } from "lit";
import { customElement as customElement6, property as property5 } from "lit/decorators.js";

// src/components/table/table-header/table-header.styles.ts
import { css as css7 } from "lit";
var table_header_styles_default = css7`
	${theme_styles_default}
	${component_styles_default}

	.header-content {
		display: flex;
		height: 64px;
	}

	.header-titles {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 12px 16px;
	}
`;

// src/components/table/table-header/table-header.ts
var TABLE_HEADER_TAG = "yotpo-table-header";
var YotpoTableHeader = class extends LitElement4 {
  constructor() {
    super(...arguments);
    this.tableTitle = "";
    this.tableSubtitle = "";
  }
  get tableTitleElement() {
    return this.tableTitle ? html7`<span part="table-title" class="yotpo-text-primary yotpo-text-large yotpo-text-bold"
					>${this.tableTitle}</span
			  >` : "";
  }
  get tableSubTitle() {
    return this.tableSubtitle ? html7`<span part="table-subtitle" class="yotpo-text-secondary yotpo-text-small"
					>${this.tableSubtitle}</span
			  >` : "";
  }
  render() {
    return html7`
			<div class="header-content">
				<span class="header-titles yotpo-theme-light">
					${this.tableTitleElement}
					${this.tableSubTitle}
				<span>
			</div>`;
  }
};
YotpoTableHeader.styles = table_header_styles_default;
__decorateClass([
  property5({ reflect: true })
], YotpoTableHeader.prototype, "tableTitle", 2);
__decorateClass([
  property5({ reflect: true })
], YotpoTableHeader.prototype, "tableSubtitle", 2);
YotpoTableHeader = __decorateClass([
  customElement6(TABLE_HEADER_TAG)
], YotpoTableHeader);

// src/components/table/secondary-actions-menu/secondary-actions-menu.ts
import { html as html8 } from "lit";
import { customElement as customElement7 } from "lit/decorators.js";
var YotpoSecondaryActionsMenu = class extends SelectableListComponent {
  constructor() {
    super();
    this.customEvents = ["yotpo-select" /* select */, "yotpo-scroll-end" /* scrollEnd */];
    this.clearWhenHidden = true;
    this.multiSelectable = false;
  }
  handlePopoverSelected(event) {
    super.handlePopoverSelected(event);
    emit(this, "yotpo-select" /* select */, { detail: event.detail });
  }
  render() {
    const secondaryActionsButton = html8`
			<yotpo-icon-button
				name="more"
				priority=${"tertiary" /* tertiary */}
				size=${"small" /* small */}
				color=${"dark" /* dark */}
				.disabled=${this.disabled}
				part="target"
			></yotpo-icon-button>
		`;
    return this.renderSelectableList(secondaryActionsButton);
  }
};
YotpoSecondaryActionsMenu = __decorateClass([
  customElement7("yotpo-secondary-actions-menu")
], YotpoSecondaryActionsMenu);
export {
  YotpoSecondaryActionsMenu,
  YotpoTable,
  YotpoTableActionsCell,
  YotpoTableCell,
  YotpoTableHeader,
  YotpoTableHeaderCell,
  YotpoTableRow
};
